import { useEffect, useState } from "react";
import { Form, Input, Button, Typography, Row, Col, message, Card, Space, Select } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftOutlined, EditOutlined, SaveOutlined } from "@ant-design/icons";
// import dayjs from 'dayjs';
import api from "../../API";

function OAAccount() {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const location = useLocation();
    const [options1, setOptions1] = useState([])
    const [options2, setOptions2] = useState([])
    const user = JSON.parse(localStorage.getItem('user'));
    const [defaultInfo, oaaccounts, subusers] = location.state;
    useEffect(() => {
        if(oaaccounts?.length) setOptions1(oaaccounts.map((oaaccount, i) => ({
            value: oaaccount.OAId,
            label: oaaccount.accountName
        })))
        if(subusers?.length) setOptions2(subusers.map(subuser => ({
            value: subuser.userId,
            label: subuser.email
        })))
        if(defaultInfo){
            form.setFieldsValue({
                OAId: defaultInfo.OAId, 
                userId: subusers?.find(subuser => subuser.email === defaultInfo.email)?.userId,
            })
        }
    }, []);

    const handleSubmit = async (values) => {
        try {
            const OASubAccountObj = {
                UserId: values.userId,
                UserId_Parent: user?.userId,
                OAId: values.OAId
            }
            let response = defaultInfo? 
                await api.update_oasubaccount_ById(defaultInfo.key, OASubAccountObj):
                await api.create_new_oasubaccount(OASubAccountObj);
            message.success(response.message);
            navigate('/oasubaccounts');
        } catch (error) {
            message.error(error.message)
        }
    };

    return (
        <Card 
            style={{ maxWidth: 800, margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
            title={
                <Space align="center">
                    <Link to={`/oasubaccounts`}>
                        <Button style={{width: 50}} icon={<ArrowLeftOutlined />}></Button>
                    </Link>
                    <Typography.Title level={5} style={{margin: 0}}>{defaultInfo? "Update": "Create New"}  Connection with SubUser</Typography.Title>
                </Space>
            }
        >
            <Form form={form} layout="vertical" onFinish={handleSubmit} initialValues={{ isActive: 1 }}>
                <Row gutter={16}>
                <Col span={24}>
                    <Form.Item label="Account Name" name="OAId" rules={[{ required: true, message: "Account Name cannot be empty" }]}>
                        <Select
                            options={options1} 
                            style={{width: "100%"}} 
                            placeholder="Select OA Account" 
                            popupMatchSelectWidth={false}
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label="SubUser email" name="userId" rules={[{ required: true, message: "SubUser email cannot be empty" }]}>
                        <Select
                            options={options2} 
                            style={{width: "100%"}} 
                            placeholder="Select SubUser Email" 
                            popupMatchSelectWidth={false}
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Form.Item>
                </Col>

               </Row>

                <Form.Item style={{ textAlign: "center" }}>
                    <Button type="primary" htmlType="submit" icon={defaultInfo? <EditOutlined/>: <SaveOutlined/>}>
                        {defaultInfo? "Update": "Save"}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}

export default OAAccount
